import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { IOption } from 'ng-select';
import { SiteCreateService } from './site-create.service';

import { CustomerSummaryService } from '../../customer';
import { IsActive } from './../../../../model';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

@Component({
  selector: 'app-site-create',
  templateUrl: './site-create.component.html',
  styleUrls: [
    // '../../../../../scss/vendors/ng-select/ng-select.scss'
  ],
  encapsulation: ViewEncapsulation.None
})

export class SiteCreateComponent implements OnInit {

  @ViewChild('successModal') successModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  customers = [];
  // customerOptions: Array<IOption> = [];
  dropdownSettings = {};

  addSiteForm: FormGroup;

  customerId: string;
  customer: Array<string> = [];
  location: String = '';
  locationShort: String = '';
  endUser: String = '';
  contactNameOne: String = '';
  contactNumberOne: String = '';
  contactEmailOne: String = '';
  contactNameTwo: String = '';
  contactNumberTwo: String = '';
  contactEmailTwo: String = '';

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private customerSummaryService: CustomerSummaryService,
    private siteCreateService: SiteCreateService,
    private translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.customerId = params.id;
    });
    translate.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Customer',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'shortName'
    };

    this.createForm();

    this.customerSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {

        this.customers = data.customerListModel;

        // const options = [];

        for (const customer of this.customers) {
          // let option: any;
          // option = { 'itemName': customer.shortName, 'id': customer.id };
          // options.push(option);

          if (customer.id == this.customerId) {
            this.addSiteForm.controls['customer'].setValue([customer]);
          }
        }

        $('div.c-btn').attr('id', 'single-select');

      }, error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  public createForm(): void {
    this.addSiteForm = this.formBuilder.group({
      customer: new FormControl([], [
        Validators.required
      ]),
      location: new FormControl('', [
        Validators.required,
        Validators.maxLength(300)
      ]),
      locationShort: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      endUser: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNameOne: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNumberOne: new FormControl('', [
        // Validators.pattern('^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$'),
        Validators.maxLength(100)
      ]),
      contactEmailOne: new FormControl('', [
        Validators.pattern('^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+(, *)?)+$'),
        Validators.maxLength(100)
      ]),
      contactNameTwo: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contactNumberTwo: new FormControl('', [
        // Validators.pattern('^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$'),
        Validators.maxLength(100)
      ]),
      contactEmailTwo: new FormControl('', [
        Validators.pattern('^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+(, *)?)+$'),
        Validators.maxLength(100)
      ]),
      remarks: new FormControl('', [
        Validators.maxLength(1000)
      ]),
    });
  }

  public addSite(addSiteForm): void {
    this.siteCreateService
      .create(addSiteForm.controls)
      .subscribe(
        data => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  public onClose(items: any) {
    if (this.addSiteForm.value.customer.length === 0) {
      this.addSiteForm.controls['customer'].setErrors({'required': true});
    }
  }

  public closeSuccessModel(): void {
    this.back();
  }

  public back(): void {
    if (this.customerId != null) {
      this.router.navigate(['/home/customers/detail/' + this.customerId]);
    } else {
      this.router.navigate(['/home/site']);
    }
  }

  public continue(): void {
    this.successModal.hide();
    // this.router.navigate([this.router.url]);

    const {
      customer, endUser,
      contactNameOne, contactNumberOne, contactEmailOne,
      contactNameTwo, contactNumberTwo, contactEmailTwo
    } = this.addSiteForm.controls;
    this.ngOnInit();
    this.addSiteForm.get('customer').setValue(customer.value);
    this.addSiteForm.get('endUser').setValue(endUser.value);
    this.addSiteForm.get('contactNameOne').setValue(contactNameOne.value);
    this.addSiteForm.get('contactNumberOne').setValue(contactNumberOne.value);
    this.addSiteForm.get('contactEmailOne').setValue(contactEmailOne.value);
    this.addSiteForm.get('contactNameTwo').setValue(contactNameTwo.value);
    this.addSiteForm.get('contactNumberTwo').setValue(contactNumberTwo.value);
    this.addSiteForm.get('contactEmailTwo').setValue(contactEmailTwo.value);
  }

  public errorClose(): void {
    if (this.redirect) {
      this.back();
    }
    else {
      this.dangerModal.hide();
    }

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-create/site-create.component.ts